import { ReactElement } from "react";
import { CardHeader } from "../../../expanded-card";
import { ReactComponent as ProfessionIcon } from "../../../../images/profile-summary/profession.svg";
import { PROFILE_SUMMARY_BASE_INFO } from "../../../../shared/data-cy";
import Label from "../../../label";
import { useTranslationWithNamespace } from "../../../../hooks";

const BASE_PATH = "profileSummary";

const Professions = ({
  children,
}: {
  children: ReactElement | ReactElement[];
}): ReactElement => {
  const { t } = useTranslationWithNamespace();

  return (
    <CardHeader
      Icon={ProfessionIcon}
      iconColor="text-primary-50"
      dataCy={`${PROFILE_SUMMARY_BASE_INFO}_profession`}
    >
      <Label
        additionalClassName="h-auto"
        dataCy={`${PROFILE_SUMMARY_BASE_INFO}_profession`}
        text={t(`${BASE_PATH}.professions`)}
      >
        <>{children}</>
      </Label>
    </CardHeader>
  );
};

export default Professions;
